import type { EtsyListing, EtsyListingImage, EtsyShop } from "../contracts.js";

const shopId = 94721036;

export const MOCK_SHOP: EtsyShop = {
  shop_id: shopId,
  shop_name: "NorthstarPrintStudio",
  title: "Editorial art for expressive spaces",
  announcement: "A small collection of bold, gallery-ready fashion prints made to bring character to your walls.",
  currency_code: "USD",
  url: "https://www.etsy.com/shop/NorthstarPrintStudio",
  icon_url_fullxfull: "/assets/catalog/gothic-blush.png",
  image_url_760x100: null,
  listing_active_count: 184,
  review_count: 1287,
  review_average: 4.9,
};

function image(file: string, alt: string): EtsyListingImage {
  return {
    rank: 1,
    url_570xN: `/assets/catalog/${file}`,
    url_fullxfull: `/assets/catalog/${file}`,
    full_width: 1200,
    full_height: 1600,
    alt_text: alt,
  };
}

function listing(id: number, title: string, file: string, amount: number, favorites: number): EtsyListing {
  return {
    listing_id: id,
    shop_id: shopId,
    title,
    description: `${title}. Museum-quality editorial print on heavyweight archival paper.`,
    state: "active",
    url: `https://www.etsy.com/listing/${id}/${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`,
    num_favorers: favorites,
    price: { amount, divisor: 100, currency_code: "USD" },
    images: [image(file, title)],
  };
}

export const MOCK_LISTINGS: EtsyListing[] = [
  listing(171001001, "Tailored — Editorial Fashion Print", "sage-tailoring.png", 2800, 412),
  listing(171001002, "Gothic Bloom Portrait Print", "gothic-blush.png", 3200, 689),
  listing(171001003, "Street Color Gallery Poster", "teal-street.png", 2600, 354),
  listing(171001004, "Citrus Pop Fashion Artwork", "citrus-pop.png", 3000, 527),
  listing(171001005, "Cobalt Form Modern Wall Art", "cobalt-form.png", 2900, 468),
];

export const MOCK_FEATURED_LISTING_IDS = [171001002, 171001004];
